import { Grid } from '@material-ui/core';
import { LayoutConstants } from '../../../../theme/LayoutConstants';
import { TagCategoryForm } from '../../../../components/tag-category/form/TagCategoryForm';
import { useTagCategoryQuery } from '../../../../graphql/models';
import { useParams } from 'react-router-dom';
import { ApiRequestErrorAndLoadingWrapper } from '../../../../components/common/ApiRequestWrapper';
import { FormBreadCrumbs } from '../../../../components/common/navigation/breadcrumbs/FormBreadcrumbs';

export const EditTagCategoryPage = (): JSX.Element => {
  const { id } = useParams<{ id: string }>();
  const numberId = Number(id);

  const { data, error, loading } = useTagCategoryQuery({
    variables: { id: numberId },
  });

  return (
    <ApiRequestErrorAndLoadingWrapper error={error} loading={loading}>
      <Grid container spacing={LayoutConstants.gridSpacing}>
        <Grid item xs={12}>
          <FormBreadCrumbs />
        </Grid>
        <Grid item xs={12}>
          <TagCategoryForm tagCategory={data?.tagCategory} />
        </Grid>
      </Grid>
    </ApiRequestErrorAndLoadingWrapper>
  );
};
